import type { TabDesignType } from "../types";

type AttributesType = {
  index: number;
  tabsInRow: number;
  total: number;
  max: number;
  design: TabDesignType;
};
export const getTitlePositionAttributes = ({
  index,
  tabsInRow,
  total,
  max,
  design,
}: AttributesType) => {
  if (!["design-1", "design-2"].includes(design)) return {};
  return {
    "data-first-in-row": index % tabsInRow === 0,
    "data-last-in-row": (index + 1) % tabsInRow === 0 || index === total - 1,
    "data-in-first-row": index < tabsInRow,
    "data-in-last-row": index >= max - tabsInRow,
  };
};
